var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pie-chart",
    clipPath: "url(#clip0_5284_68058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M17.6747 13.2416C17.1445 14.4954 16.3153 15.6001 15.2596 16.4594C14.2038 17.3186 12.9537 17.9061 11.6184 18.1706C10.2831 18.4351 8.90337 18.3684 7.59981 17.9765C6.29624 17.5845 5.10854 16.8792 4.14053 15.9222C3.17253 14.9652 2.4537 13.7856 2.04688 12.4866C1.64006 11.1876 1.55765 9.8087 1.80685 8.47049C2.05605 7.13228 2.62926 5.87548 3.47639 4.80998C4.32351 3.74449 5.41875 2.90272 6.66635 2.35829M18.333 9.99996C18.333 8.90561 18.1175 7.82198 17.6987 6.81093C17.2799 5.79988 16.6661 4.88122 15.8922 4.1074C15.1184 3.33358 14.1998 2.71975 13.1887 2.30096C12.1777 1.88217 11.094 1.66663 9.99968 1.66663V9.99996H18.333Z",
    stroke: "#475467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5284_68058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardView);
export default __webpack_public_path__ + "static/media/dashboardView.b4bd38505126a18dcc8c5bba2f9f09e3.svg";
export { ForwardRef as ReactComponent };